import {
  PropsWithChildren,
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';
import { useModalConfirm } from '#hooks/useModalConfirm';
import Icon from 'src/components/atoms/Icon';
import * as S from './styles';

interface CardNoticeProps {
  title?: string;
  body?: string;
  isVisible?: boolean;
}

export const KEY_DO_NOT_CONFIRM_NOTICE_DELETE =
  'KEY_DO_NOT_CONFIRM_NOTICE_DELETE';
export const KEY_HIDDEN_NOTICE = 'KEY_HIDDEN_NOTICE';

export default function CardNotice({
  body
}: PropsWithChildren<CardNoticeProps>) {
  const checkedDoNotConfirm = useRef<boolean>();
  const [isHiddenNotice, setIsHiddenNotice] = useState<boolean>(
    typeof window !== 'undefined' &&
      window.sessionStorage.getItem(KEY_HIDDEN_NOTICE) === body
  );
  const { openModalConfirm } = useModalConfirm();

  const handleCloseCard = useCallback(() => {
    if (
      typeof window !== 'undefined' &&
      window.localStorage.getItem(KEY_DO_NOT_CONFIRM_NOTICE_DELETE) === 'true'
    ) {
      setIsHiddenNotice(true);
      return;
    }

    openModalConfirm({
      title: '현재 공지에 대한 알림을 닫아둘까요?',
      contents: (
        <>
          우측 상단 메모 아이콘을 통해
          <br />
          공지 내용을 다시 확인하실 수 있어요!
          <S.CheckboxWrapper>
            <input
              id="check-not-show-again"
              type="checkbox"
              onChange={e => {
                checkedDoNotConfirm.current = e.target.checked;
              }}
            />
            <label htmlFor="check-not-show-again">다시 보지 않기</label>
          </S.CheckboxWrapper>
        </>
      ),
      onClickConfirm() {
        setIsHiddenNotice(true);
        if (body) {
          window.sessionStorage.setItem(KEY_HIDDEN_NOTICE, body);
        }

        if (checkedDoNotConfirm.current) {
          window.localStorage.setItem(KEY_DO_NOT_CONFIRM_NOTICE_DELETE, 'true');
        } else {
          window.localStorage.removeItem(KEY_DO_NOT_CONFIRM_NOTICE_DELETE);
        }
      }
    });
  }, [checkedDoNotConfirm, isHiddenNotice]);

  useEffect(() => {
    if (window.sessionStorage.getItem(KEY_HIDDEN_NOTICE) !== body) {
      window.sessionStorage.removeItem(KEY_HIDDEN_NOTICE);
      setIsHiddenNotice(false);
    }
  }, [body]);

  if (isHiddenNotice) {
    return null;
  }

  return (
    <S.Wrapper>
      <S.Badge>공지</S.Badge>
      <S.Contents>{body}</S.Contents>
      <S.ButtonClose onClick={handleCloseCard}>
        <Icon name="IconClose" />
      </S.ButtonClose>
    </S.Wrapper>
  );
}
